<template>
	<FontPicker 
		class="ws-font-picker"
		v-model="font"
		auto-load
		no-maches="Font not found"
	/>
</template>

<script>
import FontPicker from '@/components/elements/font-picker/FontPicker';

export default {
	name: 'WSFontPicker',
	components: { FontPicker },
	props: {
		defaultFont: {
			type: String,
			default: null
		},
		tabindex: {
			type: Number,
			required: false,
			default: 0
		}
	},
	data() {
		return {
			show: false,
		}
	},
	computed: {
		font: {
			get() {
				return this.defaultFont;
			},
			set(val) {
				this.$emit('update', val);
				this.$emit('change');
			}
		}
	}
}
</script>
